import SlideSwiperView from "components/commonComponent/slideSwiperView";
import useTopCatalogueData from "hook/useTopCatalogueData";
import {t} from "../../context/translations";
import { useSettings } from "context/SettingsContext";
const TopCategories = () => {
  const { topCatalogues, loadingTopCatalogue } = useTopCatalogueData();
  const { language } = useSettings();
  return (
    <div>
      {topCatalogues?.length > 0 && (
      <SlideSwiperView
        data={topCatalogues}
        loading={loadingTopCatalogue}
        title= {t("popularCategories", language)}
        slidesPerView={6}
        linkKey="catalogue_id"
        imageKey="image_path"
        textKey="title"
      />)}
    </div>
  );
};

export default TopCategories;